// extracted by mini-css-extract-plugin
module.exports = {"link":"profile_link__FT_R5"};